<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ status: { type: String, required: true } })
const { t } = useI18n()
const tone = computed(() => ({
  available: 'ok', rented: 'info', maintenance: 'warn', retired: 'muted',
}[props.status] || 'muted'))
</script>

<template>
  <UiStatusPill :tone="tone" variant="soft" :label="t(`vehicle.status.${status}`, status)" />
</template>
